import React, { useState, useRef} from "react";
import { Menu, X } from "lucide-react";


const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const sideNavRef = useRef(null);

  const toggleMenu = () => setIsOpen(!isOpen);


  return (
    <header className="text-gray-600 body-font relative z-50 bg-white shadow">
      <div className="container md:mx-auto flex flex-wrap md:px-10 md:py-5 px-5 py-4 flex-col md:flex-row items-center justify-between">
        {/* Mobile View */}
        <div className="md:hidden flex justify-between w-full items-center">
          <a href="/" className="flex items-center" aria-label="shinzura_logo">
            <img src="/logo_a.webp" alt="Logo" className="w-32" />
          </a>
          <button onClick={toggleMenu} className="text-black">
            {isOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>

        {/* Desktop View */}
        <div className="hidden md:flex justify-between w-full items-center">
          <a href="/" className="flex items-center" aria-label="shinzura_logo">
            <img src="/logo_a.webp" alt="Logo" className="w-48" />
          </a>

          <nav className="md:ml-auto flex text-base uppercase gap-6 relative">
            <a href="/" className="hover:text-gray-900">Home</a>
            <a href="/products" className="hover:text-gray-900">Our Products</a>
            <a href="/combos" className="hover:text-gray-900">Combos & Packs</a>
            <a href="/blogs" className="hover:text-gray-900">Blogs</a>
            <a href="/about-us" className="hover:text-gray-900">About Us</a>
          </nav>
        </div>
      </div>

      {/* Mobile SideNav */}
      {isOpen && (
        <div ref={sideNavRef} className="md:hidden absolute top-16 left-0 w-full bg-white shadow-md z-50">
          <nav className="flex flex-col text-base uppercase p-4 gap-4">
            <a href="/" className="hover:text-gray-900">Home</a>
            <a href="/products" className="hover:text-gray-900">Our Products</a>
            <a href="/combos" className="hover:text-gray-900">Combos & Packs</a>
            <a href="/blogs" className="hover:text-gray-900">Blogs</a>
            <a href="/about-us" className="hover:text-gray-900">About Us</a>
          </nav>
        </div>
      )}

      <hr />
    </header>
  );
};

export default Navbar;
